import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export class LevThreeSOne extends Component {
    render() {
        const { tagName, ServiceName, ButtonText, BgColor } = this.props;
        return (
            <div className={"card big-card white-text " + BgColor}>
                <div className="card-top">
                    <span className='text-uppercase'>{tagName}</span>
                </div>
                <div className="card-content">
                    <p className="big-card-text" dangerouslySetInnerHTML={{ __html: ServiceName }}></p>
                    <NavLink to="/" className="white-button">{ButtonText}</NavLink>
                </div>
            </div>
        );
    }
}


export class LevThreeCardSTwo extends Component {
    render() {
        const { tagName, ServiceDesc, BgColor } = this.props;
        return (
            <div className={"card style-two-card " + BgColor}>
                <div className="card-top">
                    <span className='text-uppercase'>{tagName}</span>
                </div>
                <div className="card-content">
                    <div className="card-tezt">
                        <p>{ServiceDesc}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export class LevThreeCardSThree extends Component {
    render() {
        const { tagName, ServiceDesc, BgColor } = this.props;
        return (
            <div className={"card style-three-card " + BgColor}>
                <div className="card-top">
                    <span className='text-uppercase'>{tagName}</span>
                </div>
                <div className="card-content white-text">
                 <p>{ServiceDesc}</p>
                </div>
            </div>
        );
    }
}